// @flow
import Layout from './Layout';
export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout/index.js